
import { Vue, Options, prop } from "vue-class-component";
import ModalTicketReview from "./modal-ticket-review.vue";
import { TicketDetail } from "@/domain/entities/PusatResolusiV2";

class Props {
  data = prop<TicketDetail>({
    required: true
  });
}

@Options({
  emits: ["success"],
  components: {
    ModalTicketReview
  }
})
export default class ReviewFeedback extends Vue.with(Props) {
  showModalReview = false;

  get reviewType() {
    return this.data.ticket.reviewType;
  }

  get reviewMessage() {
    return this.data.ticket.reviewMessage;
  }

  get ticketId() {
    return this.data.ticket.id.toString();
  }

  get caseNumber() {
    return this.data.ticket.caseNumber.toString();
  }

  get reviewTypeImage() {
    const image = () => {
      const obj = {
        good: require("@/app/ui/assets/svg/ics_f_thumb-good-white.svg"),
        neutral: require("@/app/ui/assets/svg/ics_f_thumb-neutral-white.svg"),
        bad: require("@/app/ui/assets/svg/ics_f_thumb-bad-white.svg")
      } as any;
      return (
        obj[this.reviewType] ??
        require("@/app/ui/assets/svg/ics_f_thumb-good-white.svg")
      );
    };
    const imageBackground = () => {
      const obj = {
        good: "bg-blue-lp-700",
        neutral: "bg-yellow-lp-1500",
        bad: "bg-red-lp-100"
      } as any;
      return obj[this.reviewType] ?? "bg-gray-lp-200";
    };
    return {
      image: image(),
      imageBackground: imageBackground()
    };
  }

  onClickReview() {
    if (this.reviewType || this.isExpiredReview) return;
    this.showModalReview = !this.showModalReview;
  }

  onSuccessReview() {
    this.onClickReview();
    this.$emit("success");
  }

  get isExpiredReview() {
    return this.data.ticket.isExpiredReview;
  }
}
